import { setSessionStorage } from '@utils/windowUtil';
/**
 * direct user to the certain component of a page
 */

export const CommentAnchorKey = 'comment-anchor';
export const CommentScrollKey = 'comment-scroll';
export const CommentAnchorCheckEvent = 'comment-anchor-check';
export const CommentScrollCheckEvent = 'comment-scroll-check';

export const CommentActionType = {
  OpenSectionComment: 'OpenSectionComment',
  OpenCommentCenter: 'OpenCommentCenter',
  CommentScrollIntoView: 'CommentScrollIntoView',
};

export function dispatchAnchorCheckEvent() {
  window.dispatchEvent(new CustomEvent(CommentAnchorCheckEvent));
}

export function dispatchCommentScrollCheckEvent() {
  window.dispatchEvent(new CustomEvent(CommentScrollCheckEvent));
}

export function addCommentAnchorRecord(record) {
  setSessionStorage(CommentAnchorKey, JSON.stringify(record));
}

export function addCommentScrollRecord(record) {
  setSessionStorage(CommentScrollKey, JSON.stringify(record));
}

export async function directUser(
  history,
  urlMap,
  targetInfo = {},
  beforeJump = () => true,
  checkSamePage = () => true,
) {
  if (!history) {
    throw new Error('missing arguments: history');
  }
  const { moduleName, componentName } = targetInfo;

  const targetModule = urlMap[moduleName];

  if (typeof beforeJump === 'function') {
    const shouldJump = await beforeJump(targetModule?.key, targetInfo);
    if (!shouldJump) {
      return;
    }
  }

  if (componentName || moduleName) {
    addCommentAnchorRecord(targetInfo);
    addCommentScrollRecord({
      ...targetInfo,
      actionType: CommentActionType.CommentScrollIntoView,
    });
  }

  if (!checkSamePage(history, targetInfo, targetModule)) {
    typeof targetModule.jump === 'function' &&
      targetModule.jump(history, targetInfo);
  } else {
    dispatchAnchorCheckEvent();
  }
}

export default {
  directUser,
  dispatchAnchorCheckEvent,
  addCommentAnchorRecord,
};
